import React from "react";
import "./Travel_With_Confidence.css";
import Common_Title from "../../common_component/common_title/Common_Title";

const TravelConfidence = () => {
  return (
    <section className="confidence-section">
      <div className="container">
        <div className="confidence-title text-center">
          <h2>
            Travel with Confidence{" "}
            <span className="highlight">We’ve Got You Covered</span>
          </h2>

          <p>
            Travel stress free knowing our experts are always available to help
            and guide you throughout your journey.
          </p>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-4">
            <div className="confidence-wrapper">
              <div className="confidence-card">
                <img
                  src="/assets/images/holidays/travel_with_confidence/real-people.png"
                  alt="support"
                  className="icon-img"
                />
                <h5>Real People, Real Support</h5>
                <p>
                  Connect with dedicated travel experts who understand your
                  booking no bots, just clear and personal assistance.
                </p>
              </div>
            </div>
            <div className="confidence-wrapper">
              <div className="confidence-card">
                <img
                  src="/assets/images/holidays/travel_with_confidence/help.png"
                  alt="local help"
                  className="icon-img"
                />
                <h5>Local Help in Critical Moments</h5>
                <p>
                  Immediate support for delays, missed confirmations, medical
                  concerns, & any unexpected situations during your trip.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 text-center">
            <div className="phone_wrapper">
              <div className="phone-image">
                <img
                  src="/assets/images/holidays/travel_with_confidence/mobile-img2.png"
                  alt="Chat Support"
                />
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="confidence-wrapper">
              <div className="confidence-card">
                <img
                  src="/assets/images/holidays/travel_with_confidence/call.png"
                  alt="call support"
                  className="icon-img"
                />
                <h5>Always Just a Call Away</h5>
                <p>
                  Our operations team is available around the clock to guide,
                  assist, and resolve any concerns during your journey.
                </p>
              </div>
            </div>

            <div className="confidence-wrapper">
              <div className="confidence-card">
                <img
                  src="/assets/images/holidays/travel_with_confidence/responsible.png"
                  alt="responsibility"
                  className="icon-img"
                />
                <h5>Responsibility Beyond Booking</h5>
                <p>
                  Our operations team is available around the clock to guide,
                  assist, and resolve any concerns during your journey.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom-note text-center">
          <p>
            “All changes and confirmations are handled by Thrillophilia-operated
            teams, not third-party vendors.”
          </p>
        </div>
      </div>
    </section>
  );
};

export default TravelConfidence;
